import { ComponentRenderProps } from '@json-render/react';

type HeadingProps = ComponentRenderProps & {
  element: {
    props: {
      level: '1' | '2' | '3' | '4';
      content: string;
    };
    children?: string[];
  };
};

export function Heading({ element }: HeadingProps) {
  const { level, content } = element.props;

  const classMap = {
    '1': 'text-2xl font-bold',
    '2': 'text-xl font-semibold',
    '3': 'text-lg font-semibold',
    '4': 'text-base font-medium',
  };

  const Tag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4';
  const className = classMap[level];

  return <Tag className={className}>{content}</Tag>;
}
